function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.748 0a1.5 1.5 0 00-1.5 1.5v5a1.5 1.5 0 001.5 1.5h7a1.5 1.5 0 001.5-1.5v-5a1.5 1.5 0 00-1.5-1.5h-7zm2.585 11a1.5 1.5 0 001.415 1h3a5.5 5.5 0 005.5-5.5v-1a1.5 1.5 0 00-1-1.415V6.5a4.5 4.5 0 01-4.5 4.5H4.333zm-.585-1a1.5 1.5 0 01-1.415-1h6.415a2.5 2.5 0 002.5-2.5V2.085a1.5 1.5 0 011 1.415v3a3.5 3.5 0 01-3.5 3.5h-5z",
  fill: "#8F90A6"
});

function SvgTasksIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTasksIcon;